import { createAxios } from 'ts/createAxios';
import { getApiPath } from 'util/commons';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import {
  UserRecycleSiteForm,
  UserSiteInfoResponse,
} from 'util/siteManagementTypes';

export const getSiteUserInfo = async (
  siteId: string,
  successCallback?: (data: UserSiteInfoResponse) => void
) => {
  const api = createAxios();
  const { data } = await api.get<UserSiteInfoResponse>(
    getApiPath(API_ENDPOINTS.SITE_INFO, { id: siteId })
  );
  successCallback?.(data);
};

export const regisRecycleProduct = async (
  params: {
    form: Partial<UserRecycleSiteForm>;
    isAuto?: boolean;
    isConsecutive?: boolean;
  },
  successCallback?: (data: { id: string }) => void
) => {
  const api = createAxios();
  const { form, isAuto, isConsecutive } = params;

  if (isAuto) {
    delete form.inputResources;
  }

  if (!isConsecutive) {
    delete form.prevProcessingObjectId;
  }

  try {
    const data = await api.post(
      isAuto && !isConsecutive
        ? API_ENDPOINTS.RECYCLE_AUTO_PROCESSING
        : API_ENDPOINTS.RECYCLE,
      {
        materialName: form.materialName,
        processingMethod: form.processingMethod,
        packingStyle: form.packingStyle,
        materialTypeId: Number(form.materialTypeId),
        gradeId: form?.grades?.find((item) => item.id === Number(form.gradeId))
          ?.id,
        weight: form.weight?.trim(),
        inputResources: form.inputResources,
        prevProcessingObjectId: form.prevProcessingObjectId,
      }
    );
    data && successCallback?.(data.data);
  } catch (error) {
    handleError(error);
  }
};
